module.exports = __webpack_public_path__ + "static/media/Fibo.2541a38c.webp";